<template>
  <LineChartGenerator :chart-data="chartData" :chart-options="options" />
</template>
<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LineController,
  LinearScale,
  CategoryScale,
  Filler,
  PointElement,
} from 'chart.js'

ChartJS.register(LineElement, Filler, PointElement, LineController, CategoryScale, LinearScale, Title, Tooltip)

export default {
  name: 'LineChart',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    LineChartGenerator,
  },
}
</script>
